import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { Button, Card, Checkbox, Form, Input, Typography, message } from 'antd';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { api } from '../api';
import { useAuth } from '../context/AuthContext';

const { Title } = Typography;

const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
`;

const StyledCard = styled(Card)`
  width: 100%;
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`;

const LoginTitle = styled(Title)`
  text-align: center;
  margin-bottom: 32px !important;
`;

interface LoginFormValues {
  email: string;
  password: string;
  remember: boolean;
}

interface LocationState {
  from?: {
    pathname: string;
  };
}

const Login: React.FC = () => {
  const [form] = Form.useForm();
  const { setAccessToken } = useAuth();
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as LocationState)?.from?.pathname || '/';
  console.log(from);

  const onFinish = async (values: LoginFormValues) => {
    try {
      setLoading(true);
      const response = await api.post('/admin/login', {
        email: values.email,
        password: values.password,
      });

      console.log(response.data);
      
      setAccessToken(response.data.access_token);
      message.success('Login successful!');
      
      if (values.remember) {
        localStorage.setItem('rememberedEmail', values.email);
      }

      navigate(from, { replace: true });
    } catch (error) {
      message.error('Login failed. Please check your credentials and try again.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginContainer>
      <StyledCard>
        <LoginTitle level={2}>Welcome Back</LoginTitle>
        <Form
          form={form}
          name="login"
          initialValues={{ 
            remember: true,
            email: localStorage.getItem('rememberedEmail') || '',
          }}
          onFinish={onFinish}
          size="large"
          layout="vertical"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'Please enter a valid email address!' }
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="Email"
              autoComplete="email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Password"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item>
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>Remember me</Checkbox>
            </Form.Item>

            <a style={{ float: 'right' }} href="/forgot-password">
              Forgot password?
            </a>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              Log in
            </Button>
          </Form.Item>
        </Form>
      </StyledCard>
    </LoginContainer>
  );
};

export default Login; 